import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

export const getCustomerUrl = (customerId: number): string =>
  resolveUrl(AppRoute.CustomersShow, { id: customerId }) ?? ''

export const getKidUrl = (kidId: number): string =>
  resolveUrl(AppRoute.KidsShow, { id: kidId }) ?? ''

export const getDisciplineUrl = (disciplineId: number): string =>
  resolveUrl(AppRoute.DisciplinesGeneralInfo, { id: disciplineId }) ?? ''
